import React from "react";
import Select from "../../shared/Select";
const SelectDuration = ({ value, required }) => {
  return (
    <Select label="Duration" name="duration" value={value} required={required}>
      <option value={""}> {"Select Duration"}</option>
      <option value={"90 days"}> {"90 days"}</option>
      <option value={"180 days"}> {"180 days"}</option>
      <option value={"365 days"}> {"365 days"}</option>
    </Select>
  );
};
export default SelectDuration;
